<template>
  <v-page page="Services" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-1>
                  <v-flex align-center>
                    <div
                      v-show="(BAN==null)||(BAN=='all')"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Services</div>
                    <div
                      v-show="(BAN!=null)&&(BAN!='all')"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Services for Account # {{ BAN }}</div>
                  </v-flex>
                  <v-flex align-center xs8>
                    <v-layout row>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlElementType"
                          v-model="filters.ElementType"
                          item-text="Text"
                          item-value="Text"
                          label="Element Type"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlDescription"
                          v-model="filters.ElementDescription"
                          item-text="Text"
                          item-value="Text"
                          label="Description"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlService"
                          v-model="filters.ServiceType"
                          item-text="Text"
                          item-value="Text"
                          label="Service"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlProvider"
                          v-model="filters.Provider"
                          item-text="Text"
                          item-value="Text"
                          label="Provider"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlStatus"
                          v-model="filters.Status"
                          item-text="Text"
                          item-value="Text"
                          label="Status"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs3 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            clearable
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterServices"
                          ></v-text-field>
                          <v-btn @click="filterServices" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- Buttons -->
                      <!-- <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          :href="printIssueList"
                          target="_blank"
                          >PRINT ISSUE LIST</a
                        >
                        <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          :href="exportToExcel"
                          target="_blank"
                          >EXPORT TO EXCEL</a
                      >-->
                      <!-- <v-btn class="TierButton mb-1 mr-2 ml-1" @click="exportToExcel">
                        <v-icon>fa-file-excel</v-icon> &nbsp; Excel
                      </v-btn>-->
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportToExcel"
                      >EXCEL</a>
                      <v-btn
                        class="TierButton mb-1 mr-0 ml-1"
                        :to="openCreateServiceRoute()"
                      >+ New Service</v-btn>
                      <createService ref="createService"></createService>
                      <editService ref="editService"></editService>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- SERVICES TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="services"
                  :item-key="services.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="pagination.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight :queries="searchHighlight">{{ props.item["AccountBAN"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left px-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ formatAccountName(props.item["AccountName1"], props.item["AccountName2"]) }}</text-highlight>
                            </span>
                          </template>
                          <span>{{props.item["AccountName2"] ? props.item["AccountName1"] +" "+ props.item["AccountName2"] : props.item["AccountName1"] }}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ElementType"] | uppercase}}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ElementDescription"] | uppercase}}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ServiceType"] | uppercase}}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["Provider"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ServiceType"] === 'Wireless' && props.item["ElementType"] !="MDN" ? formatPN_helper(props.item["Element"]) : props.item["ElementType"] =="MDN"? formatSIM(props.item["Element"]): props.item["Element"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatSIM(props.item["SecondaryIdentifier"]) }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ formatServiceInfo(props.item["ServiceInfo"]) }}</text-highlight>
                            </span>
                          </template>
                          <span>{{ props.item["ServiceInfo"] }}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-left pr-0">
                        <v-layout row>
                          <v-flex xs4>
                            <text-highlight :queries="searchHighlight">{{ props.item["Inter"] }}</text-highlight>
                          </v-flex>
                          <v-flex xs4>
                            <text-highlight :queries="searchHighlight">{{ props.item["Intra"] }}</text-highlight>
                          </v-flex>
                          <v-flex xs4>
                            <text-highlight :queries="searchHighlight">{{ props.item["Intl"] }}</text-highlight>
                          </v-flex>
                        </v-layout>
                      </td>
                      <td
                        class="text-xs-left pr-0 pl-2"
                        :class="{'green--text': props.item.Status === 'Active', 'red--text': props.item.Status === 'Cancelled'}"
                      >
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["Status"] | uppercase }}</text-highlight>
                      </td>
                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <router-link
                          class="mr-2"
                          style="text-decoration: none"
                          :to="openEditServiceRoute(props.item)"
                        >EDIT</router-link>
                        <router-link
                          class="mr-0"
                          style="text-decoration: none"
                          :to="openServiceAuditLogs(props.item)"
                        >LOG</router-link>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="pagination.totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetReceivablesList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import createService from "./CreateService";
import editService from "./EditService";
import TextHighlight from "vue-text-highlight";
import "@/assets/css/main.css";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Services",

  components: {
    VPage,
    createService,
    editService,
    "text-highlight": TextHighlight,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    searchHighlight: "",
    loading: true,

    BAN: "",

    showResetBtn: false,
    totalRecords:0,

    ddlElementType: [],
    ddlDescription: [],
    ddlService: [],
    ddlProvider: [],
    ddlStatus: [],

    filters: {},
    filtersChanged: false,

    rowsPerPageItems: [30, 45, 60, 100],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false,
      totalItems: 0,
      totalRecords:0,
      sortBy: "AccountBAN",
      page: 1
    },

    breadcrumb: [
      {
        text: "Services",
        disabled: false,
        href: "#/services/all"
      },
      {
        text: "All",
        disabled: true,
        href: "#/services/all"
      }
    ],

    headers: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "4%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "El. Type",
        value: "ElementType",
        width: "6%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Desc.",
        value: "ElementDescription",
        // sortable: false,
        width: "8%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Service",
        value: "ServiceType",
        // sortable: false,
        width: "6%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Provider",
        value: "Provider",
        // sortable: false,
        width: "8%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Service ID",
        value: "Element",
        // sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Secondary ID",
        value: "SecondaryIdentifier",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Service Info",
        value: "ServiceInfo",
        // sortable: false,
        width: "14%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Rate Plan (Inter, Intra, Intl)",
        value: "Inter",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Status",
        value: "Status",
        // sortable: false,
        width: "4%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-2"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "5%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    services: [],
    filteredServices: []
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },
   beforeRouteUpdate (to, from, next) {
     if (to.path== from.path){
       if (to.query.ServiceId != null ) {
        var ServiceId = to.query.ServiceId;
        this.openEditServiceForm({
          ServiceId: ServiceId
        });
      }
      if (to.query.createService != null ) {
        this.openCreateServiceForm();
      }
     }
    
      next()
  },
  filters: {
    uppercase: function(item) {
      if (item) {
        return item.toUpperCase();
      }
    }
  },

  methods: {
    async initialize() {
      this.loading = true;
      this.filters = {};

      this.BAN = this.$route.params.BAN;

      if (this.$route.query.search != null) {
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
      }

      if (this.BAN !== "all") {
        this.filters = {
          AccountBAN: this.BAN
        };

        this.filtersChanged = true;

        this.breadcrumb[1].text = this.BAN;
        this.showResetBtn = true;
      } else {
        this.breadcrumb[1].text = "all";
        this.filters = {};
        this.filtersChanged = true;
        this.showResetBtn = false;
      }
      var test = this.paginationUpdated();

      // var resDDL = await this.getDropDownLists()

      var elementType = await this.getDropdownOptions(
        "/api/Services/GetServicesDDLs",
        "ddlElementType"
      );
      var descriptionDDL = await this.getDropdownOptions(
        "/api/Services/GetServicesDDLs",
        "ddlDescription"
      );
      var providerDDL = await this.getDropdownOptions(
        "/api/Services/GetServicesDDLs",
        "ddlProvider"
      );
      var statusDDL = await this.getDropdownOptions(
        "/api/Services/GetServicesDDLs",
        "ddlStatus"
      );
      var serviceDDL = await this.getDropdownOptions(
        "/api/Services/GetServicesDDLs",
        "ddlService"
      );

      if (this.$route.query.ServiceId != null) {
        var serviceId = this.$route.query.ServiceId;
        this.openEditServiceForm({
          ServiceId: serviceId
        });
      }
       if (this.$route.query.createService != null ) {
        this.openCreateServiceForm();
      }

      this.loading = false;
    },

    // Get list of dropdown options
    async getDropdownOptions(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
      return true;
    },
    //     async getDropDownLists(){
    //       await axios.get("/api/Services/GetServicesDDLs").then(async res =>  {
    //         this.ddlElementType = await res.data.ddlElementType
    //         this.ddlDescription = await res.data.ddlDescription
    //         this.ddlProvider = await res.data.ddlProvider
    //         this.ddlStatus = await res.data.ddlStatus
    //         this.ddlService = await res.data.ddlStatus
    //       }).then(()=>{
    // return true
    //       })

    //     },

    async resetReceivablesList() {
      this.loading = true;
      this.$router.push("/services/all");

      this.filters = {};
      this.filtersChanged = true;
      this.searchHighlight = "";
      this.search = "";
      this.breadcrumb[1].text = "all";
      this.BAN = "all";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    openAccountSummaryPage(item) {
      return "/account-summary/" + item.AccountBAN;
    },

    formatPN_helper(num) {
      if(num){
        let formattedNum =
        "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
      return formattedNum;
      }
    },
    formatSIM(num) {
      if (num){
        let res = [...num].map((d, i) => (i) % 5 == 0 ? ' ' + d : d).join('').trim()
      return res;
      }
    },

    formatAccountName(firstName, lastName) {
      var temp;
      if (lastName == null) {
        temp = firstName.trim();
      } else if (lastName !== null) {
        temp = (firstName + " " + lastName).trim();
      }

      if (temp.length > 20) {
        return temp.substring(0, 17) + "...";
      } else {
        return temp;
      }
    },
    formatServiceInfo(item) {
      var temp = "";
      if (item) {
        temp = item.trim();
      }

      if (temp.length > 20) {
        return temp.substring(0, 17) + "...";
      } else {
        return temp;
      }
    },

    async filterServices() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()
      await this.paginationUpdated();
    },

    async openCreateServiceForm() {
      await this.$refs.createService.open({ BAN: this.BAN });
      this.deleteQueryString('createService')
    },

    async openEditServiceForm(item) {
     
      await this.$refs.editService.open({
        Id: item.ServiceId,
        BAN: item.AccountBAN,
        ElementType: item.ElementType,
        Description: item.ElementDescription,
        Service: item.ServiceType,
        Provider: item.Provider
      });

      this.deleteQueryString('ServiceId')
    },
    openEditServiceRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.ServiceId = item.ServiceId
      return {path: path, query: newQuery}
    },
     openCreateServiceRoute(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.createService = this.BAN
      return {path: path, query: newQuery}
    },
    deleteQueryString(queryString){
      let query = Object.assign({}, this.$route.query);
      delete query[`${queryString}`];
      this.$router.replace({ query });
    },
    openServiceAuditLogs(item) {
      // this.$refs.auditLogsService.openServiceAuditLogs(item);
      var BAN = item.AccountBAN;
      var ServiceId = item.ServiceId;
      return "/log/service/" + BAN + "/" + ServiceId + "/all";
    },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Services/GetPagedServiceList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.services = response.data.services;
          this.pagination.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    exportToExcel() {
      var params = {
        account: this.BAN,
        filters: this.filters,
        search: this.search
      };
      axios({
        url: "/api/Excel/services/",
        method: "POST",
        data: params,
        responseType: "blob"
      }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Services.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
    },
    updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}

/deep/.cell-overflow {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
